// src/tiles/JobTile.jsx
import React from 'react';
import TileShell from './TileShell';
import PrimaryScorePill from './PrimaryScorePill';
import ScoreBadge from './ScoreBadge';
import InterviewsBadge from './InterviewsBadge';
import ReceiptsList from './ReceiptsList';
import VariantPill from './VariantPill';
import { computeWinScore, computeGapScore } from '../../utils/scoring';
import { scoreHelp } from '../../utils/scoreHelp';

// ⬇️ NEW imports
import { useLocation } from 'react-router-dom';
import { slugify } from '../../utils/slug';

export default function JobTile({
  title, count, variant, avgImportance, avgSatisfaction, receipts, sectionTotal
}) {
  const isWin = variant === 'win';
  const winScore = computeWinScore({ importance: avgImportance, satisfaction: avgSatisfaction, interviews: count });
  const gapScore = computeGapScore({ importance: avgImportance, satisfaction: avgSatisfaction });
  const score = isWin ? winScore : gapScore;

  const help = isWin ? scoreHelp.win : scoreHelp.gap;
  const label = help.label; // 'Win Score' | 'Gap Score'
  const tone = isWin ? 'green' : 'red';
  const info = `${help.calc}\n${help.meaning}`;

  const primaryScore = (
    <PrimaryScorePill
      label={label}
      value={score}
      infoTooltip={info}
      tone={tone}
    />
  );

  const pct = sectionTotal ? Math.round((count / sectionTotal) * 100) : 0;
  const metricsRow = (
    <div style={{ display:'flex', flexWrap:'wrap', gap:8 }}>
      <InterviewsBadge percent={pct} count={count} />
      <ScoreBadge label="Importance" value={avgImportance} metricKey="importance" />
      <ScoreBadge label="Satisfaction" value={avgSatisfaction} metricKey="satisfaction" />
    </div>
  );

  // ⬇️ NEW: build deep link to the Job detail page (preserve current filters)
  const location = useLocation();
  const jobSlug = slugify(title || '');
  const linkTo = jobSlug ? `/job/${jobSlug}${location.search || ''}` : null;

  return (
    <TileShell
      typePill="job"
      variantPill={<VariantPill variant={variant} />}
      title={title}
      primaryScore={primaryScore}
      metricsRow={metricsRow}
      receipts={<ReceiptsList receipts={receipts || []} />}
      // ⬇️ NEW: pass link target for the top-right "link out" icon
      linkTo={linkTo}
      href={linkTo}
    />
  );
}
